import { render, staticRenderFns } from "./baseDataIndex.vue?vue&type=template&id=33e138c3&scoped=true"
import script from "./baseDataIndex.vue?vue&type=script&lang=js"
export * from "./baseDataIndex.vue?vue&type=script&lang=js"
import style0 from "./baseDataIndex.vue?vue&type=style&index=0&id=33e138c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e138c3",
  null
  
)

export default component.exports